export function getPrimes(max) {
  const sieve = []; let i; let j; const primes = [];
  for (i = 2; i <= max; ++i) {
    if (!sieve[i]) {
      // i has not been marked -- it is prime
      primes.push(i);
      for (j = i << 1; j <= max; j += i) {
        sieve[j] = true;
      }
    }
  }
  return primes;
}

export function arrDiff(a1, a2) {
  const a = []; const diff = [];
  for (let i = 0; i < a1.length; i++)
    a[a1[i]] = true;
  for (let i = 0; i < a2.length; i++)
    if (a[a2[i]]) delete a[a2[i]];
    else a[a2[i]] = true;
  for (const k in a)
    diff.push(parseInt(k)); // Added the parseint for factor check
  return diff;
}